import React from 'react';
import ReactDOM from 'react-dom/client';
import './utils/i18n';
import Main from './components/main';
import reportWebVitals from './reportWebVitals';
import './assets/scss/common.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Main />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
